import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { LeverageBadge, OrderSideBadge } from '@flipster/features/src/misc/badge';
import { SymbolDisplay } from '@flipster/features/src/misc/display';
import { getPositionDisplayPrice } from '@flipster/r230522/original/ticker-price';
import Formatted from '@flipster/react/design-utils/formatted';
import { V2Position } from '@flipster/socket/r230522/position';
import { flex } from '@flipster/styled-system/patterns';
import Num from '@flipster/utils/num';

import { adjustLeverageModalBunja } from '../state';

interface PositionHeaderProps {
  position: V2Position;
  pricePrecision: number;
}

export const PositionHeader = ({ position, pricePrecision }: PositionHeaderProps) => {
  const { currentPositionAtom } = useBunja(adjustLeverageModalBunja);
  const currentPosition = useAtomValue(currentPositionAtom);

  return (
    <div className={flex({ justify: 'space-between', align: 'center', pb: '12px' })}>
      <SymbolDisplay
        symbol={position.symbol}
        icon={<SymbolDisplay.Icon size={32} space={12} />}
        mainLabel={
          <SymbolDisplay.Label value='shortName' css={{ textStyle: 'Title/S', color: 'content.default.level-5' }} />
        }
        subLabel={
          <Formatted.Number
            css={{ textStyle: 'Text/L/Regular', color: 'content.default.level-2' }}
            value={currentPosition ? getPositionDisplayPrice(currentPosition) : undefined}
            precision={pricePrecision}
            toFixed
          />
        }
      />
      <div className={flex({ gap: 4 })}>
        <OrderSideBadge orderSide={Num(position.position).isGreaterThanOrEqualTo(0) ? 'Long' : 'Short'} />
        <LeverageBadge leverage={position.initLeverage} marginType={position.marginType} />
      </div>
    </div>
  );
};
